export default __webpack_public_path__ + "static/freshms-teaser2-mobile-b54f449e0942b94eeb0f9f1ea12f220e.png";